import React from 'react';
import { OptionProps, components } from 'react-select';
import { check } from 'static/icons/resizable';
import { Checkbox, Icon } from 'view/atoms';

export function OptionWithCheckIcon<T>() {
  return (props: OptionProps<T, boolean>) => {
    const { label, isSelected, innerProps, selectProps, data } = props;

    const isFirst = selectProps?.options?.[0] === data;

    const patchedInnerProps = {
      ...innerProps,
      ...(isFirst && { 'data-testid': 'dropdown-first-option-region' }),
    };

    return (
      <components.Option {...props} innerProps={patchedInnerProps}>
        {label}
        {isSelected && <Icon src={check} alt='check' />}
      </components.Option>
    );
  };
}

export function OptionWithCheckBox<T>() {
  return (props: OptionProps<T, boolean>) => {
    const { label, isSelected, innerProps, selectProps, data } = props;

    const isFirst = selectProps?.options?.[0] === data;

    const patchedInnerProps = {
      ...innerProps,
      ...(isFirst && { 'data-testid': 'dropdown-first-option-location' }),
    };

    return (
      <components.Option {...props} innerProps={patchedInnerProps}>
        <Checkbox forSelectorOption isChecked={isSelected} label={label} />
      </components.Option>
    );
  };
}
